import { NgModule } from '@angular/core';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '../common/common.module';
import { DashboardRecruitmentCfgService } from './services/dashboard-recruitment-cfg.service';
import { DashboardRecruitmentService } from './services/dashboard-recruitment.service';
import { DashboardRecruitmentCenterComponent } from './pages/dashboard-recruitment-center/dashboard-recruitment-center.component';
import { BucketFillOutExtendedKpiServiceHostComponent } from './kpi/components/bucket-fill-out-extended-kpi-service-host/bucket-fill-out-extended-kpi-service-host.component';
import { BucketPercentageExtendedKpiServiceHostComponent } from './kpi/components/bucket-percentage-extended-kpi-service-host/bucket-percentage-extended-kpi-service-host.component';
import { BucketPriorityComponent } from './kpi/components/bucket-priority/bucket-priority.component';
import { DashboardCommonModule } from "../dashboardCommon/dashboardCommon.module";
import { AuthModule } from '../auth/auth.module';
import { UtilModule } from '../util/util.module';
import { TourModule } from '../tour/tour.module';
import { DashboardRecruitmentSubsService } from './services/dashboard-recruitmen-subs.service';


@NgModule({ declarations: [
        DashboardRecruitmentCenterComponent,
        BucketFillOutExtendedKpiServiceHostComponent,
        BucketPercentageExtendedKpiServiceHostComponent,
        BucketPriorityComponent
    ],
    exports: [
        DashboardRecruitmentCenterComponent,
        BucketFillOutExtendedKpiServiceHostComponent,
        BucketPercentageExtendedKpiServiceHostComponent,
        BucketPriorityComponent
    ], imports: [AngularCommonModule,
        CommonModule,
        AuthModule,
        UtilModule,
        NgbModule,
        FormsModule,
        DashboardCommonModule,
        TourModule], providers: [
        DashboardRecruitmentCfgService,
        DashboardRecruitmentService,
        DashboardRecruitmentSubsService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class DashboardRecruitmentModule { }
